import { render } from "./MembershipPage.vue?vue&type=template&id=70472837&scoped=true"
import script from "./MembershipPage.vue?vue&type=script&lang=js"
export * from "./MembershipPage.vue?vue&type=script&lang=js"

import "./MembershipPage.vue?vue&type=style&index=0&id=70472837&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70472837"]])

export default __exports__